import {
  changeBpsCategoryIsActive,
  selectPartner360Data,
} from 'legacy/lut/features/partner360/configuration'
import { updateSectionSettings } from 'legacy/lut/features/partner360/sectionSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { BPS_CATEGORY_NOT_APPLICABLE_STATE } from '../../../config'

export const useBpsCategoryFlag = () => {
  const dispatch = useAppDispatch()
  const { planning } = useSelector(selectPartner360Data)

  const setBpsCategoryApplicable = useCallback(async () => {
    const newValue = 0 as const
    const newSettings = {
      [BPS_CATEGORY_NOT_APPLICABLE_STATE]: newValue,
    }

    await dispatch(
      updateSectionSettings({
        sectionSettings: newSettings,
        flag: BPS_CATEGORY_NOT_APPLICABLE_STATE,
        state: newValue,
        controlName: 'Planning',
      })
    ).unwrap()

    dispatch(changeBpsCategoryIsActive(true))
  }, [dispatch])

  return {
    isBpsCategoryApplicable: planning.isBpsCategoryActive,
    setBpsCategoryApplicable,
  }
}
